import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import EmailLogRow from './EmailLogRow';
import { emailLogsType, sortingParamType } from '../../types';
import SortControl from '../SortControl';
import './_styles_/EmailLogsList.css';

EmailLogsList.propTypes = {
    emailLogs: emailLogsType.isRequired,
    onSort: PropTypes.func.isRequired,
    sortingParam: sortingParamType.isRequired,
};

function EmailLogsList(props) {
    const {
        emailLogs,
        onSort,
        sortingParam,
    } = props;
    const { t } = useTranslation();
    return (
        <div className="email-logs-list">
            <div className="rich-list-row rich-list-header email-logs-list--header">
                <div className="email-log-header--values--date-time">
                    <SortControl onChange={onSort} sortingParam={sortingParam} sortingKey="dateTime">
                        {t('email-logs.list-header.date-time')}
                    </SortControl>
                </div>
                <div className="email-log-header--values--subject">
                    <SortControl onChange={onSort} sortingParam={sortingParam} sortingKey="subject">
                        {t('email-logs.list-header.subject')}
                    </SortControl>
                </div>
                <div className="email-log-header--values--recipients">
                    <SortControl onChange={onSort} sortingParam={sortingParam} sortingKey="recipients">
                        {t('email-logs.list-header.recipients')}
                    </SortControl>
                </div>
                <div className="email-log-header--values--status">
                    <SortControl onChange={onSort} sortingParam={sortingParam} sortingKey="status">
                        {t('email-logs.list-header.status')}
                    </SortControl>
                </div>
                <div className="email-log-header--values--user-id">
                    <SortControl onChange={onSort} sortingParam={sortingParam} sortingKey="userId">
                        {t('email-logs.list-header.user-id')}
                    </SortControl>
                </div>
            </div>
            {
                emailLogs.length
                    ? emailLogs.map((emailLog) => (
                        <EmailLogRow emailLog={emailLog} key={emailLog.id} />
                    ))
                    : (<div className="email-logs-no-items">{t('email-logs.no-items')}</div>)
            }
        </div>
    );
}

export default EmailLogsList;
